import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import BobLoadingMask from '../../../components/BobLoadingMask';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as BobActions from '../../../actions/bobActions';
import * as BasAgentActions from '../../../actions/basAgentActions';

import {Splitter} from '@progress/kendo-react-layout';
import Button from '@material-ui/core/Button';
import {Grid, GridColumn, GridNoRecords, GridToolbar} from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import {process as kendoProcess} from '@progress/kendo-data-query';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './AgentReport.module.css';

const initialDataState = {
    sort:   [],
    filter: [],
    group:  [{field: 'companyInfo.name'}],
    take:   20,
    skip:   0
};

const defaultCompany = {
    id:   'allCompanies',
    name: 'All Companies'
};

const AgentReportModal = ({
    activeNavCompany,
    bobLoading,
    basAgentsReport,
    clearBasAgentsReport,
    companies,
    currentUser,
    fetchBasAgentsReport,
}) => {

    const [data, setData] = useState({dataResult: kendoProcess([], initialDataState), dataState: initialDataState});
    const [pageable] = useState({pageSizes: true});
    const [take, setTake] = useState(20);
    const [selectedCompany, setSelectedCompany] = useState(defaultCompany);
    const [workbookMode, setWorkbookMode] = useState(false);
    const [companyList, setCompanyList] = useState([]);

    useEffect(() => {
        return () => {
            clearBasAgentsReport();
        };
    }, []);

    useEffect(() => {
        let tempCompanyList = [];
        if (companies.length > 0) {
            const clonedCompanies = _.cloneDeep(companies);
            tempCompanyList = clonedCompanies.sort(function (a, b) {
                if (a.company.name < b.company.name) {
                    return -1;
                }
                else if (a.company.name > b.company.name) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            tempCompanyList.unshift({ company: defaultCompany });
            setCompanyList(tempCompanyList.map(c => c.company));
        }
    }, [companies]);

    useEffect(() => {
        if (basAgentsReport && basAgentsReport !== null) {
            setData({dataResult: kendoProcess(basAgentsReport, initialDataState), dataState: initialDataState});
        }
        else {
            setData({dataResult: [], dataState: initialDataState});
        }
    }, [basAgentsReport]);

    useEffect(() => {
        if (!workbookMode) {
            initialDataState.filter = [];
            initialDataState.take = take;
            const dataResult = basAgentsReport && basAgentsReport !== null ? kendoProcess(basAgentsReport, initialDataState) : [];
            setData({dataResult: dataResult, dataState: initialDataState});
        }
    }, [workbookMode]);

    const onDataStateChange = event => {
        setTake(event.dataState.take);
        setData({dataResult: kendoProcess(basAgentsReport, event.dataState), dataState: event.dataState});
    };

    const onExpandChange = event => {
        const expandField = event.target.props.expandField || '';
        event.dataItem[expandField] = event.value;
        setData({...data});
    };

    let _export;
    const exportExcel = () => {
        if (data.dataResult && data.dataResult.data.length > 0) {
            _export.save();
        }
    };

    const handleWorkbookMode = () => {
        setWorkbookMode(!workbookMode);
    };

    const renderConnectedCell = props => {
        let isConnected = '';
        if ('connected' in props.dataItem) {
            isConnected = props.dataItem.connected !== null ? props.dataItem.connected.toString() : '';
        }
        return (<td style={{textTransform: 'capitalize'}}>{isConnected}</td>);
    };

    const handleCompanyChange = (props, value) => {
        setSelectedCompany(value);
    };

    const handleGenerate = async event => {
        if (selectedCompany) {
            const companyId = selectedCompany.id === 'allCompanies' ? activeNavCompany.id : selectedCompany.id;
            const options = {};
            options.isSuperAdmin = selectedCompany.id === 'allCompanies';
            await fetchBasAgentsReport(companyId, options);
        }
        else {
            alert('Select a company');
        }
    };

    const getFileName = () => {
        const currentDate = moment().format('YYYY-MM-DD h:mm A');
        return `BAS Agent Report ${currentDate}.xlsx`;
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
                {
                    `.k-splitter-flex .k-pane-static {
                        flex-grow: 0;
                        flex-shrink: 0;
                        flex-basis: fit-content;
                    }
                    `
                }
            </style>
            <Splitter
                panes={[{size: '300px', resizable: false}, {resizable: false}]}
                orientation={'horizontal'}
            >
                <div style={{padding: '10px'}}>
                    <div>
                        <Autocomplete
                            id="company-select"
                            style={{width: 280}}
                            options={companyList}
                            defaultValue={defaultCompany}
                            autoHighlight
                            getOptionLabel={(option) => option.name}
                            onChange={handleCompanyChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Company"
                                    variant="outlined"
                                    size="small"
                                    required
                                    error={!selectedCompany}
                                    inputProps={{
                                        ...params.inputProps
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div style={{paddingTop: '10px'}}>
                        <Button
                            className={classes.Button}
                            onClick={handleGenerate}
                            variant="outlined"
                            size="small"
                        >
                            Generate
                        </Button>
                    </div>
                </div>
                <div style={{padding: '10px'}}>
                    <style>
                        {
                            `.k-textbox {
                                font-size: 1.2rem;
                            }
                            .k-numerictextbox {
                                font-size: 1.2rem;
                            }
                            .k-dropdown {
                                font-size: 1.2rem;
                            }`
                        }
                    </style>
                    <div className={classes.Table}>
                        <ExcelExport
                            data={basAgentsReport && basAgentsReport !== null ? kendoProcess(basAgentsReport, {group: data.dataState.group, filter: data.dataState.filter}).data : []}
                            ref={exporter => {_export = exporter;}}
                            collapsible
                            fileName={getFileName()}
                            filterable
                            group={data && data !== null ? data.dataState.group : []}
                        >
                            <Grid
                                className={classes.KendoGrid}
                                data={data.dataResult}
                                sortable={true}
                                groupable={true}
                                pageable={pageable}
                                filterable={workbookMode}
                                onDataStateChange={onDataStateChange}
                                onExpandChange={onExpandChange}
                                {...data.dataState}
                                expandField="expanded"
                            >
                                {
                                    bobLoading.includes('FetchBasAgents') ?
                                        <GridNoRecords>
                                            Loading BAS Agent data
                                        </GridNoRecords>
                                        :
                                        <GridNoRecords>
                                            No BAS Agents found
                                        </GridNoRecords>
                                }
                                <GridToolbar>
                                    <div className={classes.wrapper}>
                                        <div className={classes.exportCell}>
                                            <Button
                                                className={classes.ButtonOutlinedMode}
                                                size="medium"
                                                variant="outlined"
                                                onClick={exportExcel}
                                            >
                                                Export
                                            </Button>
                                        </div>
                                        <div className={classes.workbookCell}>
                                            <Button
                                                className={workbookMode ? classes.ButtonContainedMode : classes.ButtonOutlinedMode}
                                                size="medium"
                                                variant={workbookMode ? 'contained' : 'outlined' }
                                                onClick={handleWorkbookMode}
                                            >
                                                Workbook Mode
                                            </Button>
                                        </div>
                                    </div>
                                </GridToolbar>
                                <GridColumn
                                    title={'Company'}
                                    field={'companyInfo.name'}
                                    width={250}
                                />
                                <GridColumn
                                    title={'Agent Name'}
                                    field={'name'}
                                    width={250}
                                />
                                <GridColumn
                                    title={'Driver'}
                                    field={'driverType'}
                                    width={200}
                                />
                                <GridColumn
                                    title={'Serial Number'}
                                    field={'serialNumber'}
                                    width={265}
                                />
                                <GridColumn
                                    title={'Version'}
                                    field={'firmwareVersion'}
                                    width={265}
                                />
                                <GridColumn
                                    title={'Connected'}
                                    field={'connected'}
                                    width={145}
                                    filter={'boolean'}
                                    cell={renderConnectedCell}
                                />
                            </Grid>
                        </ExcelExport>
                        { bobLoading.includes('FetchBasAgents') ?
                            <BobLoadingMask />
                            : null
                        }
                    </div>
                </div>
            </Splitter>

        </React.Fragment>
    );
};


export const mapStateToProps = (state) => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    basAgentsReport:  state.basAgent.basAgentsReport,
    companies:        state.core.companies,
    currentUser:      state.currentUser

});

const mapDispatchToProps = {
    ...BasAgentActions,
    ...BobActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentReportModal);
